import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WorkflowService } from '../../service/workflow.service';
import { DocumentReviewsService } from '../../service/crud-entity-services/document-reviews.service';
import { Router} from '@angular/router';
import { EntityList } from '../../objects/entity-list';
import { EntityType, QuestionGroup, WorkflowStatus } from '../../objects/interface-library';
import { EntityWorkflowManagementComponent } from '../../entity-form-components/entity-workflow-management/entity-workflow-management.component';
import * as docReviewColumns from '../../shared/entity-columns/doc-review-columns';
import { WorkflowQuestionsComponent } from '../../entity-form-components/workflow-questions/workflow-questions.component';
import { DocumentReview } from '../../objects/doc-review';
import { FormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatButtonModule } from '@angular/material/button'; 
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { AgGridModule } from 'ag-grid-angular';

let _ = require('lodash');



@Component({
    selector: 'app-document-review-list',
    templateUrl: './document-review-list.component.html',
    styleUrls: ['./document-review-list.component.css'],
    standalone: true,
    imports: [
      AgGridModule,
      MatButtonModule,
      MatFormFieldModule,
      MatSelectModule,
      FormsModule,
      MatGridListModule,
      MatDividerModule,
      MatSidenavModule,
      MatButtonToggleModule
    ]
  })
export class DocumentReviewListComponent extends EntityList implements OnInit {

  // defaultColDef = { resizable: true,
  //                   sortable: true,
  //                   filter: true
  //                 };

  showNameSavedView = false;  // shows the dialog to save a named view
  nameOfSavedView = null; // if you are showing the ability to name a view what name did the customer type
  savedUserViews = []; // list of all the previously saved user views
  savedViewToLoadName = null;  // value of the drop down of previously saved views
  loadSavedReportVisible = false; // Shows the select drop down to load a saved report


  // Boolean values controling HTML show/hide
  customizeCoumnsUi = false;
  waitingForServer = false;
  customizeColumnsUi = false;

  userRole = null;

  workflowList = [];
  selectedStatuses = null;
  selectedEntityType = EntityType.Contract;

  // columnApi = null;
  // gridApi = null;

  allColumns = docReviewColumns.allColumns;

  columnSelectList = docReviewColumns.columnSelectList;

  selectedCols = [];

  defaultUserViewCols = [
    docReviewColumns.colPriority,
    docReviewColumns.colRequestor,
    docReviewColumns.colAssignedTo,
    docReviewColumns.colPhase,
    docReviewColumns.colName,
    docReviewColumns.colDocumentType,
    docReviewColumns.colSubmissionDate,
    docReviewColumns.colDaysInProcess,
    docReviewColumns.colCreatedDate,
    docReviewColumns.colEffectiveDate,
    docReviewColumns.colStatus,
    docReviewColumns.colInternalCoordinators
  ];

  constructor(
              private workflowService: WorkflowService,
              public router: Router,
              public dialog: MatDialog,
              
              public docReviewsService: DocumentReviewsService
              ) { 

    super();

  }

  async ngOnInit() {


  }


  openOigExclusions() {
    window.open('https://exclusions.oig.hhs.gov/', "_blank");
  }

  openDocuSign() {
    window.open('https://app.docusign.com/home', "_blank");
  }

  openAdobeSign() {
    window.open('https://secure.echosign.com/public/login', "_blank");
  }


  async updateUserView() {

    this.workflowList = [];

    // if (this.selectedStatuses.length > 0) {

    //   this.selectedStatuses.forEach(async status => {
    //     let currentStatusList = await this.workflowService.getRequests(status, this.selectedEntityType);
    //     this.workflowList = this.workflowList.concat(currentStatusList);
    //   });
  
    // }
  }


  userChangedStatusView(event) {
    // console.log('user view status value: ', event.value);
    // console.log('selected statuses: ', this.selectedStatuses);
    // console.log('entity type: ', this.selectedEntityType);
    this.updateUserView();
  }







  fixColumnWidths() {
    this.gridApi.sizeColumnsToFit();
  }


  // This is the filter.   Needs a new name.
  onSearchChange(filterValue) {
    this.gridApi.setGridOption('quickFilterText', filterValue);
  }



  async onCellClicked(event) {

    console.log('*** onCellClicked doc review *** impl');

    let response = await this.workflowService.getRequestByNum(event.data.Id);

    this.router.navigateByUrl('/securehome/new-document-review');
  }



  onColumnMoved(event) {
    console.log('onColumnMoved event: ', event);
  }

  showSaveNamedView() {
    this.showNameSavedView = !this.showNameSavedView;
  }


  presentWorkflowQuestions() {

    const dialogRef = this.dialog.open(WorkflowQuestionsComponent, {
      width: '1500px',
      height: '500px',
      data: {
              questionGroup: QuestionGroup.PhysicianEmploymentAgreement,
            }
    });

    dialogRef.afterClosed().subscribe(async result => {

      if (result) {

        // this.globalDataService.currentDocumentReview.questions = result;

        this.router.navigateByUrl('/securehome/new-document-review');
      } else {
        this.router.navigateByUrl('/securehome/new-document-review');
      }
    });

  }

  createNewDocReview() {
    // 1. LAUNCH MODEL DIALOG

    const dialogRef = this.dialog.open(EntityWorkflowManagementComponent, {
      width: '1000px',
      // data: {
      //         criticalDateData: importantDateData,
      //         message: 'You opened an important date from the date list.',
      //         title: 'Edit Important Date'
      //       }
    });

    dialogRef.afterClosed().subscribe(async result => {

      // this.globalDataService.currentDocumentReview = new DocumentReview();

      // if (result) {
      //   console.log('*** result of workflow prompt: ', result);

      //   result.amountThreshold ? this.globalDataService.currentDocumentReview.threshold = result.amountThreshold : this.globalDataService.currentDocumentReview.threshold = 0;
      //   result.documentType ? this.globalDataService.currentDocumentReview.documentType = result.documentType : this.globalDataService.currentDocumentReview.documentType = null;
      //   result.amountThreshold ? this.globalDataService.currentDocumentReview.transactionType = result.transactionType : this.globalDataService.currentDocumentReview.transactionType = null;
      //   // this.globalDataService.currentDocumentReview.contractType = result.contractType;
      //   // this.globalDataService.currentDocumentReview.contractType = result.contractType;
      //   // this.globalDataService.currentDocumentReview.contractType = result.contractType;
      //   if (result.contractType === 'Physician: Employment Agreement') {
      //     this.globalDataService.currentDocumentReview.contractType = result.contractType;          
      //     this.presentWorkflowQuestions();
      //   } else if (result.contractType) {
      //     this.globalDataService.currentDocumentReview.contractType = result.contractType;          
      //     this.router.navigateByUrl('/securehome/new-document-review');          
      //   } else {
      //     this.router.navigateByUrl('/securehome/new-document-review');
      //   }
      // } else {
      //   this.router.navigateByUrl('/securehome/new-document-review');
      // }
    });



    // 2. IF THEY PICK PHYSICIAN AGREEMTN THEN GIVE QUESTIONAIRE
    // 3. IF NOT THEN JUST GO TO INTAKE FORM
  }

  saveDocReviewListAsCSV() {
    console.log('save list as csv');
    // this.gridApi.exportDataAsCsv();
  }

  saveDocReviewListAsExcel() {
    console.log('save list as excel');
    // this.gridApi.exportDataAsExcel();
  }

  customizeColumns() {
    this.customizeColumnsUi = !this.customizeColumnsUi;
  }

  // openSavedReportsDialog() and other view management methods are inherited from EntityList base class

  refreshAllDocuments() {
    console.log('refresh all documents');
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();

    this.columnApi = params.api;
  }

}
